export const theme = {
  lineColors: ["#27AE60", "#F17D32"],
};
